const COLOR_PRIMARY = '#0077BE';
const COLOR_SUCCESS = '#43a047';
const COLOR_DANGER = '#e53935';

export { COLOR_PRIMARY, COLOR_SUCCESS, COLOR_DANGER };
